import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

    interface Props {
        value: number | null;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGCarYearSelect',
  props: {
    value: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'input', year: number | null): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as {
        value: number | null;
    };

    

    

    const year = computed<number | null>({
        get() {
            return props.value;
        },
        set(newVal: number | null) {
            emit('input', newVal);
        },
    });

return { __sfc: true,props, emit, year }
}

})